/**
 * Reglas de adjuntos del chat. Deben coincidir con
 * `server/src/constants/chatUploads.js`, que es quien valida de verdad.
 */

export const CHAT_UPLOAD_MAX_BYTES = 40 * 1024 * 1024;

export const CHAT_ALLOWED_UPLOAD_TYPES = {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
};

export const CHAT_UPLOAD_ACCEPT = '.png,.jpg,.jpeg,.pdf,.doc,.docx';

export const CHAT_UPLOAD_HINT = 'Imágenes PNG o JPG, Word y PDF · máx. 40 MB';

const IMAGE_MIME_TYPES = ['image/png', 'image/jpeg'];

const WORD_MIME_TYPES = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const getFileExtension = (fileName = '') => {
    const dot = String(fileName).lastIndexOf('.');
    return dot === -1 ? '' : String(fileName).slice(dot).toLowerCase();
};

export const isImageAttachment = (mimeType) => IMAGE_MIME_TYPES.includes(mimeType);

export const getAttachmentKind = (mimeType) => {
    if (isImageAttachment(mimeType)) return 'image';
    if (mimeType === 'application/pdf') return 'pdf';
    if (WORD_MIME_TYPES.includes(mimeType)) return 'word';
    return 'file';
};

export const ATTACHMENT_KIND_LABELS = {
    image: 'Imagen',
    pdf: 'PDF',
    word: 'Documento Word',
    file: 'Archivo',
};

/** Algunos navegadores no reportan el MIME; se deduce desde la extensión. */
export const resolveMimeType = (file) => {
    if (file?.type && CHAT_ALLOWED_UPLOAD_TYPES[file.type]) return file.type;

    const extension = getFileExtension(file?.name);
    const match = Object.entries(CHAT_ALLOWED_UPLOAD_TYPES)
        .find(([, extensions]) => extensions.includes(extension));

    return match ? match[0] : (file?.type || '');
};

export const formatFileSize = (bytes) => {
    const value = Number(bytes);
    if (!Number.isFinite(value) || value <= 0) return '';
    if (value < 1024) return `${value} B`;
    if (value < 1024 * 1024) return `${Math.round(value / 1024)} KB`;
    return `${(value / (1024 * 1024)).toFixed(1)} MB`;
};

/**
 * @returns {{ valid: true, mimeType: string } | { valid: false, message: string }}
 */
export const validateChatFile = (file) => {
    const mimeType = resolveMimeType(file);
    const extension = getFileExtension(file?.name);
    const allowedForMime = CHAT_ALLOWED_UPLOAD_TYPES[mimeType];

    if (!allowedForMime || !allowedForMime.includes(extension)) {
        return {
            valid: false,
            message: 'Formato no permitido. Solo imágenes PNG o JPG, documentos Word y PDF.',
        };
    }

    if (!file.size) {
        return { valid: false, message: 'El archivo está vacío.' };
    }

    if (file.size > CHAT_UPLOAD_MAX_BYTES) {
        return { valid: false, message: 'El archivo no puede superar 40 MB.' };
    }

    return { valid: true, mimeType };
};
